export enum DeeplinkStatus {
    Active = "active",
    Inactive = "inactive",
}